import React, { Component } from "react";
import ButtonPrimary from "../../../../shared/items/contols/buttonPrimary";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import styles from "./../cmsCompanies.module.scss";

class CmsTransferCompanyTools extends Component {
  render() {
    const { ownershipAreas, viewOwnershipAreaId, handleClick, onSelectArea } = this.props;

    return (
      <FormControl variant="standard" sx={{ m: 1, minWidth: 250, display: "inline-block" }}>
        <div style={{ display: "flex" }}>
          <Select
            style={{ minWidth: "270px" }}
            onChange={onSelectArea}
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
          >
            <MenuItem value={null} className={styles.MuiButtonBase_resolve}>
              {"- - - "}
            </MenuItem>
            {ownershipAreas
              .filter((x) => {
                return x.id !== viewOwnershipAreaId;
              })
              .map((area) => {
                return (
                  <MenuItem key={area.id} value={area.id} className={styles.MuiButtonBase_resolve}>
                    {area.title}
                  </MenuItem>
                );
              })}
          </Select>
          <div style={{ paddingLeft: "15px" }}>
            <ButtonPrimary handleClick={handleClick} title="Перенести компанию" />
          </div>
        </div>
      </FormControl>
    );
  }
}

export default CmsTransferCompanyTools;
